import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface StoryMeta {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
  isLocked: boolean;
  storyMode: string;
}

const FALLBACK_STORIES: StoryMeta[] = [
  { id: '1', title: 'A Night in Paris', description: 'Strangers. One hotel. Two cocktails.', imageSrc: '', isLocked: false, storyMode: 'soft' },
  { id: '2', title: 'The Photographer', description: 'A private shoot. No rules.', imageSrc: '', isLocked: false, storyMode: 'steamy' },
  { id: '3', title: 'Cabin Fever', description: 'Snowed in. No Wi-Fi. Just us.', imageSrc: '', isLocked: false, storyMode: 'soft' },
  { id: '4', title: 'First Date Redux', description: 'Pretend you just met tonight.', imageSrc: '', isLocked: false, storyMode: 'steamy' },
  { id: '5', title: 'The Masquerade', description: 'Masks on. Identities off.', imageSrc: '', isLocked: false, storyMode: 'wild' },
  { id: '6', title: 'Road Trip Detour', description: 'Wrong turn. Best night.', imageSrc: '', isLocked: false, storyMode: 'wild' },
  { id: '7', title: 'The Love Letter', description: 'Found in a drawer. Read aloud.', imageSrc: '', isLocked: false, storyMode: 'soft' },
];

export function useStories() {
  const [stories, setStories] = useState<StoryMeta[]>(FALLBACK_STORIES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchStories() {
      try {
        const docRef = doc(db, 'couple-en', 'storyList');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const fetched = data.stories as StoryMeta[];
          if (fetched?.length) {
            setStories(fetched);
          }
        }
      } catch {
        // Fall back to static data silently
      } finally {
        setLoading(false);
      }
    }

    fetchStories();
  }, []);

  return { stories, loading };
}
